import { render, staticRenderFns } from "./ActiveDetail.vue?vue&type=template&id=53a05960&scoped=true&"
import script from "./ActiveDetail.vue?vue&type=script&lang=js&"
export * from "./ActiveDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActiveDetail.vue?vue&type=style&index=0&id=53a05960&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a05960",
  null
  
)

export default component.exports